export enum ManagementFieldType {
  TEXT = "Texto",
  DROPDOWN = "Dropdown",
}

export enum ManagementFieldRequiredIn {
  REGISTRATION = "REGISTRATION",
  STATUS = "STATUS",
}

export interface ManagementField {
  name: string;
  type: string;
  order: number;
  // Ausente em campos cadastrados antes da flag existir: equivale a "Sim".
  export_client?: boolean;
  required?: boolean;
  // Ausente em campos obrigatórios cadastrados antes da opção: Dados Cadastrais.
  required_in?: ManagementFieldRequiredIn;
  // Único status do projeto em que o campo é exigido (required_in = STATUS).
  required_status?: string;
  // Itens do Dropdown, na ordem configurada.
  options?: string[];
}

// Campos dropdown dos Dados Cadastrais que aceitam opções personalizadas.
export enum CustomFieldOptionField {
  EVENT_TYPE = "event_type",
  EVENT_FORMAT = "event_format",
}

// Opções extras de um campo, somadas às opções padrão só para o cliente.
export interface CustomFieldOption {
  field: CustomFieldOptionField;
  options: string[];
}

export interface Client {
  _id: string;
  name: string;
  nickname: string;
  email: string;
  address: string;
  tax_id: string;
  segment: string;
  logo_url?: string;
  management_fields?: ManagementField[];
  custom_field_options?: CustomFieldOption[];
}
